var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[(_vm.header)?_c('div',{staticClass:"header flex justify-between",class:{ 'justify-between': _vm.header, 'justify-end': !_vm.header }},[_c('h2',{staticClass:"flex-grow-1"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_vm._t("header-append")],2):_vm._e(),_c('div',{staticClass:"table"},[_vm._t("table")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }